import TopLevelMethod from "../../core/TopLevelMethod";
import ViewerMethod from "../../core/ViewerMethod";
import {
  getStartActionName,
  getSuccessActionName,
} from "../../core/make-action";
import { combineReducers } from "redux";
import {
  UserPreference,
  UserBookPreference,
  isValidPreferenceItem,
} from "./utils";

type ApiMethod = TopLevelMethod | ViewerMethod;

function getCleanedPrefs(preferences, validValues) {
  const finalPrefs = { ...preferences };
  Object.entries(preferences).forEach(([key, value]) => {
    if (!isValidPreferenceItem(value) || !validValues.includes(key)) {
      delete finalPrefs[key];
    }
  });
  return finalPrefs;
}

function makePrefsReducer(
  fetchMethod: ApiMethod,
  updateMethod: ApiMethod,
  validValues: string[]
) {
  return function prefsReducer(state = {}, action) {
    switch (action.type) {
      case getSuccessActionName(fetchMethod):
        let preferences = action.resultData.preferences || {};
        return getCleanedPrefs(preferences, validValues);
      case getStartActionName(updateMethod):
        const newPrefs = action.apiCallArgs[0];
        return getCleanedPrefs({ ...state, ...newPrefs }, validValues);
      default:
        return state;
    }
  };
}

const reducer = combineReducers({
  user: makePrefsReducer(
    TopLevelMethod.GET_USER_INFO,
    TopLevelMethod.UPDATE_USER_PREFS,
    Object.values(UserPreference)
  ),
  book: makePrefsReducer(
    ViewerMethod.GET_BOOK_INFO,
    ViewerMethod.UPDATE_USER_BOOK_PREFS,
    Object.values(UserBookPreference)
  ),
});

export default reducer;
